import { useEffect, useState } from 'react'
import { NoteCode } from '@user/components/Notes/typings'
import { useAppDispatch } from '@user/store/hooks'
import { getNoteCodes, getNoteSettings } from '@user/store/notes/api'
import { DefaultNoteModel } from '@user/components/Settings/Notes/typings'

export function useData() {
  const [noteCodes, setNoteCodes] = useState<NoteCode[]>([])
  const [formDefaultValues, setFormDefaultValues] = useState<DefaultNoteModel>({
    defaultNoteCodeId: '',
    noteAutomationEnabled: false,
  })

  const dispatch = useAppDispatch()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const getAllNoteSettings = async () => {
      try {
        const result = await dispatch(getNoteSettings())
        if (getNoteSettings.fulfilled.match(result)) {
          const { payload } = result
          setFormDefaultValues({
            defaultNoteCodeId: payload.defaultNoteCodeId ?? '',
            noteAutomationEnabled: payload.noteAutomationEnabled,
          })
        }
      } catch (error) {
        setNoteCodes([])
      }
    }
    const getAllNoteCodes = async () => {
      try {
        const result = await dispatch(getNoteCodes())
        if (getNoteCodes.fulfilled.match(result)) {
          const { payload } = result
          setNoteCodes(payload?.items || [])
        }
      } catch (error) {
        setNoteCodes([])
      }
    }

    const loadData = async () => {
      await Promise.all([getAllNoteSettings(), getAllNoteCodes()])
      setLoading(false)
    }

    loadData()
  }, [dispatch, getNoteSettings, getNoteCodes])

  return {
    noteCodes,
    formDefaultValues,
    loading,
  }
}
